import { render } from "./AboutView.vue?vue&type=template&id=203b69e0"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=203b69e0&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__